export default "__VITE_ASSET__3194763e__"